import React from "react";
import { motion } from "framer-motion";
import about_us_WhatDifferentiates_img from "../../Assets/images/about_us_WhatDifferentiates_img.png";
import aboutUs_arrow_icon from "../../Assets/images/aboutUs_arrow_icon.svg";

const motionVariants = [
  {
    hidden: { opacity: 0, y: -40 },
    visible: { opacity: 1, y: 0 },
  },
  {
    hidden: { opacity: 0, x: -100 },
    visible: { opacity: 1, x: 0 },
  },
  {
    hidden: { opacity: 0, x: 100 },
    visible: { opacity: 1, x: 0 },
  },
  {
    hidden: { opacity: 0, y: 40 },
    visible: { opacity: 1, y: 0 },
  },
];

const motionProperties = {
  initial: "hidden",
  whileInView: "visible",
  transition: { duration: 1, delay: 0.5 },
};

const WhatDifferentiates = () => {
  return (
    <div>
      <div className="flex items-center justify-between">
        <motion.div {...motionProperties} variants={motionVariants[0]}>
          <img
            src={about_us_WhatDifferentiates_img}
            alt="img"
            className="w-[150px]"
          />
        </motion.div>
        <motion.div {...motionProperties} variants={motionVariants[1]}>
          <h1 className="lg:text-4xl md:text-2xl text-lg font-bold lg:w-[70%] w-[80%] text-center m-auto text-slate-200">
            What Differentiates us from other Online Boot Camps?
          </h1>
        </motion.div>
        <motion.div {...motionProperties} variants={motionVariants[2]}>
          <img
            src={about_us_WhatDifferentiates_img}
            alt="img"
            className="w-[150px] scale-x-[-1]"
          />
        </motion.div>
      </div>
      <motion.p
        {...motionProperties}
        variants={motionVariants[3]}
        className="my-4 text-center text-slate-300"
      >
        At Techmentee, we are helping individuals fast-forward their careers!
      </motion.p>

      <div className="grid lg:grid-cols-2 grid-cols-1 gap-8 py-6">
        {[0, 1, 2, 3].map((i) => (
          <motion.div
            key={i}
            {...motionProperties}
            variants={motionVariants[i % motionVariants.length]}
            className="flex md:gap-0 gap-2"
          >
            <div className="w-[6%]">
              <img src={aboutUs_arrow_icon} alt="arrow icon" className="" />
            </div>
            <div className="w-[94%]">
              <h1 className="md:text-xl text-lg font-semibold text-slate-200">
                {i === 0 && (
                  <>
                    Have an <b className="text-primaryOrangeColor">Immersive</b>{" "}
                    Learning Experience.
                  </>
                )}
                {i === 1 && (
                  <>
                    <b className="text-primaryOrangeColor">Develop</b> Skills
                    with Applied Learning.
                  </>
                )}
                {i === 2 && (
                  <>
                    Structured Guidance so that Learning{" "}
                    <b className="text-primaryOrangeColor">Never Stops.</b>
                  </>
                )}
                {i === 3 && (
                  <>
                    Get <b className="text-primaryOrangeColor">Job-Ready</b>{" "}
                    with Top-Quality Curriculum.
                  </>
                )}
              </h1>
              <p className="text-slate-300 mt-1">
                {i === 0 &&
                  "Learn from practitioners bringing the best practices into sessions to make your learning experience immersive."}
                {i === 1 &&
                  "Get your hands on distinct real-world projects to master the skill of hands-on learning."}
                {i === 2 &&
                  "Constant learning support from experts and a like-minded community of peers to help you get ahead with learning."}
                {i === 3 &&
                  "Upscale yourself for real career growth with top-quality industry-specific academic curriculum."}
              </p>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default WhatDifferentiates;
